export default function (Vue, parent, _data) {
  var line_normal = {
    template: `
    <div class='__config__body'>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">

           <el-form label-width="65px">
            <el-form-item label="流向标识：" v-show=false>
                <el-input v-model="data['id']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="源自节点：">
                <el-input v-model="params['fromName']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="目标节点：">
                <el-input v-model="params['toName']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="源自节点：" v-show="false">
                <el-input v-model="data['from']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="目标节点：" v-show="false">
                <el-input v-model="data['to']" :disabled="true"></el-input>
            </el-form-item>
             <el-form-item label="流向名称：">
                <el-input v-model="data['name']"></el-input>
            </el-form-item>
            <el-form-item label="流向提示：">
                <el-input v-model="data['tip']"></el-input>
            </el-form-item>
            <el-form-item label="流向标识：">
                <el-input v-model="data['dMark']" style="width:calc(100% - 48px);"></el-input>
                <el-button type="primary" @click="showFlowMarks()">选择</el-button>
            </el-form-item>
            <el-form-item label="流向序号：">
                <el-input v-model="data['sn']"></el-input>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="流程控制" name="2">
           <el-form label-width="92px">
           <el-form-item label="显示条件：">
                <el-input v-model="data['condition']" style="width:85%"></el-input>
                <el-tooltip placement="top">
                  <div slot="content">
                  内置上下文：<br/>
                  * $form 表单数据 <br/>
                  * $user 当前登录用户数据<br/>
                  内置函数：<br/>
                  * $R('角色名', ...) 具有指定角色<br/>
                  * $D('部门名称 xxx/yyy/zzz') 属于指定部门<br/>
                  * $DR('部门名称', '角色名', ...) 具有指定部门的角色<br/>
                  * $G('组名称') 属于指定组<br/>
                  * $GR('组名称', '角色名', ...)<br/>
                  * $DA('部门名称') 是否部门管理员<br/>
                  * $GA('组名称') 是否组管理员<br/>
                  * $U('用户登录ID', ...) 在指定的用户名列表中<br/>
                  * $sysAdmin 是否系统管理<br/>
                 例如:不具有主管和副经理的角色并且申请天数(表域名：fldtianshu)大于2<br/>
                    Js脚本表达式：     !$R('主管','副经理') && $vi($f.fldtianshu)>2 <br/>
                    groovy脚本表达式： $p{!$R('主管','副经理')} && xt.vi($form.fldtianshu)>2 <br/>
                    </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>

            </el-form-item>
            <el-form-item label="流向类型：">
                <el-select v-model="data['type']" @change="changeType">
                  <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="经办节点：" v-show="data['type'] === 'sendHandled' ">
                <el-input v-model="data['handleActivityName']"  :disabled="true" style="width:60%"></el-input>
                <el-button type="primary"  @click="showHandledNode({id:'handleActivityId', name:'handleActivityName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="经办节点" v-show="false">
                  <el-input v-model="data['handleActivityId']" :disabled="true"></el-input>
            </el-form-item>
           <el-form-item label="同一流程：" v-show="data['type'] === 'sendHandled'">
               <el-radio-group v-model="data['sameProcess']">
               <el-radio  label="1">是</el-radio>
               <el-radio  label="0">否</el-radio>
               </el-radio-group>
           </el-form-item>
           <el-form-item label="运转类型：" v-show="data['type'] === 'startSubProcess' ">
                <el-select v-model="data['sendUnit']" @change="changeSendUnit">
                  <el-option
                    v-for="item in sendUnits"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运转规则：" v-show="data['type'] === 'startSubProcess' ">
                <el-select v-model="data['sendRule']">
                  <el-option
                    v-for="item in sendRules"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发送到运转：" v-show="data['type'] === 'startSubProcess' ">
                <el-radio-group v-model="data['sendToYz']">
                <el-radio  label="0">是</el-radio>
                <el-radio  label="1">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="等待完成：" v-show="data['type'] === 'startSubProcess' ">
                <el-radio-group v-model="data['waitComplete']">
                <el-radio  label="1">是</el-radio>
                <el-radio  label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="跳转待办：" v-show="data['type'] === 'startSubProcess' ">
                <el-radio-group v-model="data['skipTodo']" size="mini">
                  <el-radio-button label="1">开</el-radio-button>
                  <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="跳转模式：" v-show="data['type'] === 'startSubProcess' && data['skipTodo'] === '1' ">
                <el-radio-group v-model="data['skipTodoMode']">
                <el-radio  label="userComplete">用户</el-radio>
                <el-radio  label="activityComplete">节点</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="干预父任务：" v-show="data['type'] === 'startSubProcess' ">
                <el-radio-group v-model="data['interventionParentTask']" size="mini">
                  <el-radio-button label="1">开</el-radio-button>
                  <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="跳转节点：" v-show="data['type'] === 'startSubProcess' && data['interventionParentTask']=='1' ">
                <el-input v-model="data['skipToActivityName']" :disabled="true" style="width:60%;"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'skipToActivityId', name:'skipToActivityName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="跳转节点:" v-show="false">
                  <el-input v-model="data['skipToActivityId']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="办理部门：" v-show="data['type'] != 'sendHandled' ">
                <el-select v-model="data['groupType']">
                  <el-option
                    v-for="item in groupTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="相对部门：" v-show="data['type'] != 'sendHandled' && data['groupType'] === 'relative' ">
                <el-input v-model="data['relativeGroupName']" style="width:60%;" :disabled="true"></el-input>
                <el-button type="primary" @click="showDept">选择</el-button>
            </el-form-item>
             <el-form-item label="相对部门" v-show="false">
                  <el-input v-model="data['relativeGroup']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="部门字段："  v-show="data['type'] != 'sendHandled' && data['groupType'] === 'biz' ">
                <el-input v-model="data['groupField']"></el-input>
            </el-form-item>
            <el-form-item label="部门经办节点：" v-show="data['type'] != 'sendHandled' && data['groupType'] === 'handled-group' ">
                <el-input v-model="data['groupHandledActName']"  :disabled="true" style="width:60%"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'groupHandled', name:'groupHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="部门经办节点" v-show="false">
                  <el-input v-model="data['groupHandled']" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="部门范围：" v-show="data['type'] != 'sendHandled' && data['groupType']!='no'">
                <el-select v-model="data['group']">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排除条件：" v-show="data['type']!= 'sendHandled' &&　data['groupType'] != 'no' ">
                <el-radio-group v-model="data['excludeSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排除范围：" v-show="data['type']!= 'sendHandled' &&　data['groupType'] != 'no' && data['excludeSwitch']== '1' ">
                <el-select v-model="data['excludeType']">
                  <el-option
                    v-for="item in excludeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="部门内抢办：">
              <el-radio-group v-model="data['singleDepartmentRecord']" size="mini" v-show="data['type'] === 'startSubProcess' ">
                <el-radio-button label="true">开</el-radio-button>
                <el-radio-button label="false">关</el-radio-button>
               </el-radio-group>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="表单控制" name="3">
           <el-form label-width="92px">
            <el-form-item label="运转跟踪单位：" v-show="data['type'] === 'startSubProcess' ">
                <el-select v-model="data['workTrackUnit']">
                  <el-option
                    v-for="item in workTrackUnits"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择单位：" v-show="data['type'] != 'startSubProcess' || data['sendUnit']!='USER'">
                <el-select v-model="data['selectUnit']" :disabled="data['type'] === 'startSubProcess' && data['sendUnit']==='DEP'">
                  <el-option
                    v-for="item in selectUnits"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择单位：" v-show="data['type'] === 'startSubProcess' && data['sendUnit']==='USER'">
                <el-select v-model="data['selectUnit']">
                  <el-option
                    v-for="item in workUserSelectUnits"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="办理单位：" v-show="data['selectUnit'] != 'position' ">
                <el-select v-model="data['activityUnit']" :disabled="data['type'] === 'startSubProcess' ">
                  <el-option
                    v-for="item in activityUnits"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="合并到上级：" v-show="data['type'] != 'startSubProcess' || data['sendUnit']==='DEP' ">
                <el-select v-model="data['mergeType']">
                  <el-option
                    v-for="item in mergeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="直接发送：">
                <el-radio-group v-model="data['sendDirectly']">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="任务提示：">
                <el-input v-model="data['taskTip']"></el-input>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="其他" name="4">
           <el-form  label-width="65px">
            <el-form-item label="执行脚本：">
                <el-button type="primary" @click="showFlowScriptSet('line')">设置</el-button>
            </el-form-item>
            </el-form>
        </el-collapse-item>
      </el-collapse>
</div>
    `,
    props: {
      data: {
        type: Object
      },
      params:{
        type: Object
      }
    },
    data() {
      return {
        activeName: '1',
        types:[{value:'normal',label:'普通'},{value:'startSubProcess',label:'运转'},{value:'sendHandled',label:'直送经办'}],

        groupTypes:[{value:'no',label:'不启用'},{value:'role',label:'权限'},{value:'relative',label:'相对部门'},{value:'handled-group',label:'经办'},{value:'biz',label:'业务指定'},{value:'upper-group',label:'发送部门'},{value:'draft-group',label:'发起部门'}],

        groups:[{value:'<当前>', label:'<当前>'},{value:'<上级>', label:'<上级>'}, {value:'<下级>', label:'<下级>'}, {value:'<平级>', label:'<平级>'},
          {value:'<当前和上级>', label:'<当前和上级>'},{value:'<当前和下级>', label:'<当前和下级>'},
          {value:'<所有下级>', label:'<所有下级>'}, {value:'<上级的平级>', label:'<上级的平级>'},
          {value:'<本部门任选>', label:'<本部门任选>'},{value:'<部门上级>', label:'<部门上级>'}, {value:'<部门下级>', label:'<部门下级>'}, {value:'<部门平级>', label:'<部门平级>'},
          {value:'<本单位任选>', label:'<本单位任选>'},{value:'<本单位任选(不包含下级)>', label:'<本单位任选(不包含下级)>'},
          {value:'<本单位的一级部门>', label:'<本单位的一级部门>'},{value:'<单位上级>', label:'<单位上级>'},{value:'<单位平级>', label:'<单位平级>'},
          {value:'<上级单位部门>', label:'<上级单位部门>'},{value:'<上级单位任选>', label:'<上级单位任选>'}/*, {value:'<任选>', label:'<任选>'}*/],
        sendUnits:[{value:'USER', label:'人员'},{value:'DEP', label:'部门'}],
        sendRules:[{value:'batch', label:'按批次'},{value:'process', label:'按流程'}],
        selectUnits:[{value:'user', label:'人员'},{value:'group', label:'部门'},{value:'user-tree', label:'人员树'},{value:'group-tree', label:'部门树'}/*,{value:'position', label:'岗位'}*/],
        workUserSelectUnits:[{value:'user', label:'人员'},{value:'user-tree', label:'人员树'}],
        activityUnits:[{value:'group', label:'部门'},{value:'user', label:'人员'}],
        mergeTypes:[{value:'no', label:'不启用'},{value:'dep', label:'部门'},{value:'unit', label:'单位'}],
        workTrackUnits:[{value:'activity', label:'当前节点'},{value:'user', label:'当前用户'}],
        excludeTypes:[{value:'current-user', label:'当前用户'},{value:'current-dep', label:'当前部门'}]
      };
    },

    created() {
      this.initData();
    },

    watch: {
      'data.id': function (val, oldVal) {
        this.initData();
      },
      'data.tip':function(val, oldVal){
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateLine", {id: me.data.id, tip: val})
        }
      }
    },
    methods:{
      initData(){
        if(this.data.type == undefined){
          this.$set(this.data, 'type', this.types[0].value);
        };
        if(this.data.groupType == undefined){
          this.$set(this.data, 'groupType', 'no');
        };
        if(this.data.sendToYz == undefined){
          this.$set(this.data, 'sendToYz', '0');
        }
        if(this.data.group == undefined){
          this.$set(this.data, 'group', '<当前>');
        };
        if(this.data.excludeSwitch == undefined){
          this.$set(this.data, 'excludeSwitch', '0');
        };
        if(this.data.sendDirectly == undefined){
          this.$set(this.data, 'sendDirectly', '1');
        };
        if(this.data.selectUnit == undefined){
          this.$set(this.data,'selectUnit','user-tree');
        }
        if(this.data.activityUnit == undefined){
          this.$set(this.data,'activityUnit','group');
        }
        if(this.data.mergeType == undefined){
          this.$set(this.data, 'mergeType', 'no');
        };
        if(this.data.workTrackUnit == undefined){
          this.$set(this.data, 'workTrackUnit', this.workTrackUnits[0].value);
        };
        if(this.data.excludeType == undefined){
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        };
        if(this.data.scriptActions == undefined){
          this.$set(this.data, 'scriptActions', {});
        }
        /*if(this.data.multipleUnit == undefined){
          this.$set(this.data, 'multipleUnit', '0');
        };*/
      },
      showHandledNode(f){
        var me =  this;
        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        PF.show('tree',{treeData:me._getActivities(['start','end','circular','sub-proc'],f.id == "skipToActivityId"), selectFirst:false, selectNode:selectNode},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });

      },
      showDept(){
        var me  = this;
        var selectNode = '';
        if(me.data['relativeGroup']){
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree',{url: this.mwUrl("/api/org/listDepartment"), selectFirst:false,selectNode:selectNode, search:true, async:true, singleLeaf:false},function(res){
          me.$set(me.data,'relativeGroup',res.id);
          me.$set(me.data,'relativeGroupName',res.name);
        });
      },
      showFlowScriptSet(type){
        var me = this;
        var p = {};
        p.size='small_mini';
        p.type = type;
        var scriptActions = me.data.scriptActions;
        if(scriptActions){
          p.scriptActions = scriptActions;
        }else{
          p.scriptActions ={};
        }
        PF.show('flowScriptSet',p,function(res){
          me.$set(me.data,'scriptActions',res);
        })
      },
      changeType:function(val){
        parent.$emit("updateLine", {id: this.data.id, type: val})
        if(this.data.type=="sendHandled"){
          if(this.data.sameProcess==undefined){
            this.$set(this.data, 'sameProcess', '0');
          }
        }
        if(this.data.type === 'startSubProcess'){
          //this.$set(this.data, 'multipleUnit', '1'); //运转流向允许多选
          if(this.data.waitComplete == undefined){
            this.$set(this.data, 'waitComplete', '0');
          }
          if(this.data.sendToYz == undefined){
            this.$set(this.data, 'sendToYz', '0');
          }
          if(this.data.skipTodo == undefined){
            this.$set(this.data, 'skipTodo', '1');
          }
          if(this.data.skipTodoMode == undefined){
            this.$set(this.data, 'skipTodoMode', 'activityComplete');
          }
          if(this.data.interventionParentTask == undefined){
            this.$set(this.data, 'interventionParentTask', '0');
          }
          if(this.data.workTrackUnit == undefined){
            this.$set(this.data, 'workTrackUnit', this.workTrackUnits[0].value);
          }
          if(this.data.sendUnit == undefined){
            this.$set(this.data, 'sendUnit', this.sendUnits[0].value);
          }
          if(this.data.sendRule== undefined){
            this.$set(this.data, 'sendRule', this.sendRules[0].value);
          }

          if(this.data.sendUnit === 'DEP'){
            this.$set(this.data,'selectUnit','group');
            this.$set(this.data,'activityUnit','group');
          }else{
            this.$set(this.data,'selectUnit','user');
            this.$set(this.data,'activityUnit','user');
            this.$set(this.data, 'mergeType', 'no');
          }
        }else{
          //this.$set(this.data, 'multipleUnit', '0');
          this.$set(this.data,'selectUnit','user-tree');
          this.$set(this.data,'activityUnit','group');
          this.$set(this.data, 'mergeType', 'no');
        }
      },
      changeSendUnit:function(val){
        if(val === 'DEP'){
          this.$set(this.data,'selectUnit','group');
          this.$set(this.data,'activityUnit','group');
        }else{
          this.$set(this.data,'selectUnit','user');
          this.$set(this.data,'activityUnit','user');
          this.$set(this.data, 'mergeType', 'no');
        }
      },
      showFlowMarks(){
        var me = this;
        var flowMarks = me.params.flowMarks||"";
        if(!flowMarks){
          PF.message("请在模块设置中配置流程标识");
          return;
        }
        flowMarks = _.uniq(flowMarks.split(","));
        var treeData = [];
        _.each(flowMarks,function(v){treeData.push({id:v,name:v})})
        var checkNodes = (me.data.dMark||"").split(",");
        PF.show('tree',{treeData:treeData,checkNodes:checkNodes, multiple:true,clearBtn:true},function(res){
          var marks = [];
          _.each(res,function(v){
            marks.push(v.name);
          })
          me.$set(me.data,'dMark',marks.join(","));
        });
      },
      _getActivities(excludeActivityTypes,isSkipToActivity){
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(a=>{
          exclude = false;
          excludeActivityTypes.forEach(et=>{
            if(et==a.extends){
              exclude = true;
            }
          });
          if(!exclude){
            treeData.push({id:a.id, text:a.parameters.name, name:a.parameters.name});
          }
        });
        if(isSkipToActivity){//支持运转干预父结点跳转到结束
          var flows =  me.params.processDataItems["SEQUENCE-FLOW"];
          var flowDirs = _.filter(flows,function(a){return a.sourceId==me.data.from})
          var nodeIds = [];
          _.each(flowDirs,function(v){nodeIds.push(v.targetId)});
          _.each(activities,function(v){
            if(nodeIds.indexOf(v.id) != -1 && v.extends=='end'){
              treeData.push({id:v.id, text:v.parameters.name, name:v.parameters.name});
            }
          })
        }
        return treeData;
      }
    }
  }

  return line_normal
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/line_normal.js